export default __webpack_public_path__ + "static/media/house.80f0cd1e.svg";